import { Link } from 'react-router-dom';
import { categories, siteInfo } from '@/mocks/home';
import { useState } from 'react';

export default function Footer() {
  const [email, setEmail] = useState('');
  const [statusMsg, setStatusMsg] = useState('');
  const [isSuccess, setIsSuccess] = useState(false);
  const [submitting, setSubmitting] = useState(false);

  const handleSubscribe = async (e: React.FormEvent<HTMLFormElement>) => {
    e.preventDefault();
    const form = e.currentTarget;
    const honeypotEl = form.querySelector<HTMLInputElement>('[name="phone_alt"]');
    if (honeypotEl && honeypotEl.value.trim() !== '') {
      setIsSuccess(true);
      setStatusMsg('订阅成功！感谢关注~');
      return;
    }

    setSubmitting(true);
    try {
      const formData = new FormData(form);
      const res = await fetch('http://ekaichem.com/', {
        method: 'POST',
        headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
        body: new URLSearchParams(formData as unknown as Record<string, string>).toString(),
      });
      const responseText = await res.text();
      let parsed: { code?: string; meta?: { message?: string; detail?: string }; message?: string } | null = null;
      try { parsed = JSON.parse(responseText); } catch { /* ignore */ }

      const serverMsg = parsed?.meta?.message || parsed?.message || parsed?.meta?.detail || responseText;
      const isSpam = typeof serverMsg === 'string' && serverMsg.includes('spam');

      if (res.ok && parsed?.code === 'OK') {
        setIsSuccess(true);
        setStatusMsg('订阅成功！感谢关注~');
        setEmail('');
      } else if (isSpam) {
        setStatusMsg(serverMsg);
      } else {
        setStatusMsg(serverMsg || '订阅失败，请稍后再试');
      }
    } catch {
      setStatusMsg('网络错误，请稍后再试');
    } finally {
      setSubmitting(false);
    }
  };

  return (
    <footer className="bg-foreground-950 text-background-200">
      <div className="max-w-[1400px] mx-auto px-4 md:px-6 py-16">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-12 gap-10">
          <div className="lg:col-span-4">
            <Link to="/" className="text-2xl font-bold font-heading text-background-50 whitespace-nowrap">
              韩漫吧
            </Link>
            <p className="mt-4 text-sm text-foreground-400 leading-relaxed max-w-sm">
              {siteInfo.description}
            </p>
            <div className="flex items-center gap-4 mt-6">
              <a href="#" className="w-9 h-9 flex items-center justify-center rounded-full bg-foreground-800 text-background-200 hover:bg-accent-500 hover:text-background-50 transition-colors duration-200" rel="nofollow" aria-label="微博">
                <i className="ri-weibo-line"></i>
              </a>
              <a href="#" className="w-9 h-9 flex items-center justify-center rounded-full bg-foreground-800 text-background-200 hover:bg-accent-500 hover:text-background-50 transition-colors duration-200" rel="nofollow" aria-label="微信">
                <i className="ri-wechat-line"></i>
              </a>
              <a href="#" className="w-9 h-9 flex items-center justify-center rounded-full bg-foreground-800 text-background-200 hover:bg-accent-500 hover:text-background-50 transition-colors duration-200" rel="nofollow" aria-label="QQ">
                <i className="ri-qq-line"></i>
              </a>
              <a href="#" className="w-9 h-9 flex items-center justify-center rounded-full bg-foreground-800 text-background-200 hover:bg-accent-500 hover:text-background-50 transition-colors duration-200" rel="nofollow" aria-label="B站">
                <i className="ri-bilibili-line"></i>
              </a>
            </div>
          </div>

          <div className="lg:col-span-2">
            <h4 className="text-sm font-semibold text-background-100 mb-4 whitespace-nowrap">快速链接</h4>
            <ul className="space-y-3">
              <li><Link to="/" className="text-sm text-foreground-400 hover:text-background-100 transition-colors duration-150 whitespace-nowrap">首页</Link></li>
              <li><Link to="/about" className="text-sm text-foreground-400 hover:text-background-100 transition-colors duration-150 whitespace-nowrap">关于我们</Link></li>
              <li><a href="#" className="text-sm text-foreground-400 hover:text-background-100 transition-colors duration-150 whitespace-nowrap">阅读指南</a></li>
              <li><a href="#" className="text-sm text-foreground-400 hover:text-background-100 transition-colors duration-150 whitespace-nowrap">常见问题</a></li>
            </ul>
          </div>

          <div className="lg:col-span-3">
            <h4 className="text-sm font-semibold text-background-100 mb-4 whitespace-nowrap">热门分类</h4>
            <ul className="space-y-3">
              {categories.slice(0, 5).map((cat) => (
                <li key={cat.slug}>
                  <Link to={`/category/${cat.slug}`} className="text-sm text-foreground-400 hover:text-background-100 transition-colors duration-150 whitespace-nowrap">
                    {cat.name}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          <div className="lg:col-span-3">
            <h4 className="text-sm font-semibold text-background-100 mb-4 whitespace-nowrap">订阅更新</h4>
            <p className="text-sm text-foreground-500 mb-4 leading-relaxed">第一时间获取最新韩漫更新通知</p>
            {isSuccess && statusMsg.includes('成功') ? (
              <div className="bg-accent-500/20 border border-accent-500/30 rounded-lg px-4 py-3 text-sm text-accent-300">
                <span className="w-4 h-4 inline-flex items-center justify-center mr-2">
                  <i className="ri-checkbox-circle-fill"></i>
                </span>
                {statusMsg}
              </div>
            ) : (
              <form onSubmit={handleSubscribe}>
                <input
                  type="text"
                  name="phone_alt"
                  tabIndex={-1}
                  autoComplete="off"
                  aria-hidden="true"
                  readOnly
                  className="honeypot-field"
                />
                <div className="flex flex-col sm:flex-row gap-2">
                  <input
                    type="email"
                    name="email"
                    value={email}
                    onChange={(e) => setEmail(e.target.value)}
                    placeholder="输入你的邮箱"
                    required
                    className="flex-1 bg-foreground-800 border border-foreground-700 rounded-lg px-4 py-2.5 text-sm text-background-100 placeholder:text-foreground-500 focus:outline-none focus:border-accent-500 transition-colors duration-150"
                  />
                  <button type="submit" disabled={submitting} className="bg-accent-500 text-background-50 px-5 py-2.5 rounded-lg text-sm font-medium whitespace-nowrap hover:bg-accent-600 transition-colors duration-200 disabled:opacity-60">
                    {submitting ? '提交中...' : '订阅'}
                    <span className="w-4 h-4 inline-flex items-center justify-center ml-1">
                      <i className="ri-arrow-right-line"></i>
                    </span>
                  </button>
                </div>
                {statusMsg && !statusMsg.includes('成功') && (
                  <p className="mt-2 text-xs text-red-400">{statusMsg}</p>
                )}
              </form>
            )}
          </div>
        </div>

        <div className="mt-12 pt-8 border-t border-foreground-800 flex flex-col sm:flex-row items-center justify-between gap-4">
          <p className="text-xs text-foreground-500">
            &copy; {siteInfo.founded} - {new Date().getFullYear()} 韩漫吧 HanManBa. All rights reserved.
          </p>
          <div className="flex items-center gap-6">
            <a href="#" className="text-xs text-foreground-500 hover:text-background-200 transition-colors duration-150 whitespace-nowrap">隐私政策</a>
            <a href="#" className="text-xs text-foreground-500 hover:text-background-200 transition-colors duration-150 whitespace-nowrap">服务条款</a>
            <a href="#" className="text-xs text-foreground-500 hover:text-background-200 transition-colors duration-150 whitespace-nowrap">版权声明</a>
          </div>
        </div>
      </div>
    </footer>
  );
}